function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0-share{fill:url(#SVGID_1_);stroke:#3F1573;stroke-width:10;stroke-miterlimit:10;}\n\t.st1-share{fill:url(#SVGID_2_);}\n\t.st2-share{fill:url(#SVGID_3_);}\n\t.st3-share{fill:url(#SVGID_4_);}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0-share",
  d: "M488.62,12.55c-42.53,0-77,34.47-77,77c0,17.41,5.79,33.47,15.53,46.37 c-23.84,47.58-65.88,85.79-115.5,105.03c-12.48-8.72-27.65-13.85-44.04-13.85c-14.55,0-28.16,4.04-39.77,11.06 c-10.25-6.34-20.5-12.67-30.75-19.01c-6.71-4.15-13.49-8.35-19.08-13.92c-7.11-7.08-12.03-16.3-14.08-26.11 c3.65-8.96,5.68-18.75,5.68-29.02c0-42.53-34.47-77-77-77s-77,34.47-77,77s34.47,77,77,77c16.68,0,32.12-5.32,44.73-14.34 c6.51,1.79,12.57,5.54,18.26,9.33c10.59,7.06,21,14.71,29.03,24.58c6.22,7.65,10.91,16.82,12.47,26.48 c-4.16,9.47-6.49,19.94-6.49,30.95c0,42.53,34.47,77,77,77s77-34.47,77-77c0-11.27-2.44-21.97-6.79-31.61 c3.1-8.16,8.62-15.56,14.43-22.23c26.41-30.33,60.9-52.56,96.67-70.94c8.05-4.13,16.39-8.27,22.69-14.67 c5.47,1.23,11.16,1.91,17,1.91c42.53,0,77-34.47,77-77S531.15,12.55,488.62,12.55z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st1-share",
  d: "M54.16,103.4c11.2-9.11,25.07-15.22,39.48-16s29.3,4.04,39.68,14.08c5.54,5.36,9.67,11.98,13.52,18.65 c2.25,3.9,4.5,8.19,3.03,13.22c-5-6.93-13.79-10.91-22.3-10.11c-6.34,0.6-12.19,3.61-18.43,4.85c-3.65,0.72-7.53,0.81-11.02-0.51 c-2.17-0.83-4.09-2.16-6.06-3.39c-8.05-5-17.07-8.22-26-11.39c-5.92-2.11-12.46-4.21-18.33-1.98 C52.55,104.81,58.73,99.89,54.16,103.4z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st2-share",
  d: "M231.16,255.4c11.2-9.11,25.07-15.22,39.48-16c14.42-0.78,29.3,4.04,39.68,14.08 c5.54,5.36,9.67,11.98,13.52,18.65c2.25,3.9,4.5,8.19,3.03,13.22c-5-6.93-13.79-10.91-22.3-10.11c-6.34,0.6-12.19,3.61-18.43,4.85 c-3.65,0.72-7.53,0.81-11.02-0.51c-2.17-0.83-4.09-2.16-6.06-3.39c-8.05-5-17.07-8.22-26-11.39c-5.92-2.11-12.46-4.21-18.33-1.98 C229.55,256.81,235.73,251.89,231.16,255.4z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st3-share",
  d: "M453.16,40.4c11.2-9.11,25.07-15.22,39.48-16c14.42-0.78,29.3,4.04,39.68,14.08 c5.54,5.36,9.67,11.98,13.52,18.65c2.25,3.9,4.5,8.19,3.03,13.22c-5-6.93-13.79-10.91-22.3-10.11c-6.34,0.6-12.19,3.61-18.43,4.85 c-3.65,0.72-7.53,0.81-11.02-0.51c-2.17-0.83-4.09-2.16-6.06-3.39c-8.05-5-17.07-8.22-26-11.39c-5.92-2.11-12.46-4.21-18.33-1.98 C451.55,41.81,457.73,36.89,453.16,40.4z"
});

function SvgShareIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 573.12 384.64",
    style: {
      enableBackground: "new 0 0 573.12 384.64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 108.1764,
    y1: 141.7432,
    x2: 526.2147,
    y2: 300.1498,
    gradientTransform: "matrix(1 0 0 -1 0 396.102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#273995"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7CCED0"
    }
  })), _ref3)), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.1561,
    y1: 232.4766,
    x2: 131.6278,
    y2: 327.1911,
    gradientTransform: "matrix(1 0 0 -1 0 396.102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2749,
    style: {
      stopColor: "#283B95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7659,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _ref4, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.1562,
    y1: 80.4766,
    x2: 308.6279,
    y2: 175.1911,
    gradientTransform: "matrix(1 0 0 -1 0 396.102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411,
    style: {
      stopColor: "#4065A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8256,
    style: {
      stopColor: "#F7F9FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _ref5, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 494.3611,
    y1: 315.4986,
    x2: 504.9062,
    y2: 380.5963,
    gradientTransform: "matrix(1 0 0 -1 0 396.102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2644,
    style: {
      stopColor: "#71B9C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon3);
export default __webpack_public_path__ + "static/media/share-icon-3.8f02293d.svg";
export { ForwardRef as ReactComponent };